"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./BackToApointmentsRequest"), exports);
__exportStar(require("./BackToQueueRequest"), exports);
__exportStar(require("./BookAppointmentRequest"), exports);
__exportStar(require("./UpdateAppointmentRequest"), exports);
__exportStar(require("./CancelAppointmentRequest"), exports);
__exportStar(require("./ConfirmAppointmentRequest"), exports);
__exportStar(require("./CopyPlaceRequest"), exports);
__exportStar(require("./FinishProcessingRequest"), exports);
__exportStar(require("./InviteAppointmentRequest"), exports);
__exportStar(require("./PauseQueueRequest"), exports);
__exportStar(require("./PhoneNumberLookupRequest"), exports);
__exportStar(require("./QueueInAppointmentRequest"), exports);
__exportStar(require("./WalkInRequest"), exports);
__exportStar(require("./RejectAppointmentRequest"), exports);
__exportStar(require("./RemoveCommentRequest"), exports);
__exportStar(require("./MessageCostsRequest"), exports);
__exportStar(require("./CreateOrganisationRequest"), exports);
__exportStar(require("./AcceptInvitationRequest"), exports);
__exportStar(require("./DeclineInvitationRequest"), exports);
__exportStar(require("./WithdrawInvitationRequest"), exports);
__exportStar(require("./InviteOrgMemberRequest"), exports);
__exportStar(require("./RemoveOrgMemberRequest"), exports);
__exportStar(require("./ResendOrgMemberInviteRequest"), exports);
__exportStar(require("./UpdateOrganisationRequest"), exports);
__exportStar(require("./UpdateOrgMemberRequest"), exports);
__exportStar(require("./MigratePlaceRequest"), exports);
__exportStar(require("./MigrateTicketsRequest"), exports);
//responses
__exportStar(require("./CopyPlaceResponse"), exports);
__exportStar(require("./PhoneNumberLookupResponse"), exports);
__exportStar(require("./MessageCostsResponse"), exports);
__exportStar(require("./CreateOrganisationResponse"), exports);
//Urls
__exportStar(require("./Urls"), exports);
//# sourceMappingURL=index.js.map